import { usePostHog } from 'posthog-js/react';
import { useEffect } from 'react';
import { NavigateFunction, useNavigate } from 'react-router-dom';

import { useEventContext } from '../../hooks/contexts/event.context';
import { useModalContext } from '../../hooks/contexts/modal.context';
import { useUserContext } from '../../hooks/contexts/user.context';
import useAuthing from '../../hooks/useAuthing';
import { Event } from '../../types/event';
import { User } from '../../types/user';

type AuthProps = {
  path: 'login' | 'register' | 'trusted';
  cachedRoute?: string | boolean;
  isTicketPage?: boolean;
  validateCart?: ({
    user,
    event,
    navigate,
  }: {
    user: User;
    event: Event;
    navigate: NavigateFunction;
  }) => Promise<boolean>;
};

const Auth = ({ path, cachedRoute = false, validateCart, isTicketPage }: AuthProps) => {
  const posthog = usePostHog();
  const { elementId } = useAuthing(path);
  const { toggleModal } = useModalContext();
  const { authenticatedUser, user, handleAuthenticatedUser } = useUserContext();
  const { event } = useEventContext();
  const navigate = useNavigate();

  const navigateToCachedRoute = () => {
    if (typeof cachedRoute === 'string') {
      toggleModal({ open : false });
      navigate(cachedRoute, { replace : false, state : { from : null } });
    }
  };

  const validateLogin = async () => {
    if (isTicketPage && user && event && validateCart) {
      const isValid = await validateCart({ user, event, navigate });
      toggleModal({ open : false });
      posthog?.identify(
        String(user.id),
        { email : user.email, name : user.name }
      );

      if (!isValid) {
        handleAuthenticatedUser(false);
        return;
      }
    }

    navigateToCachedRoute();
  };

  useEffect(() => {
    if (!authenticatedUser || !cachedRoute) return;

    validateLogin();
  }, [authenticatedUser]);

  return <section style={{ width : '500px', height : '540px' }} id={elementId} />;
};

export default Auth;
